import React from 'react'
import DatePickerMulti from 'react-multi-date-picker'
import Button from 'react-multi-date-picker/components/button'
import { BiCalendarAlt, BiCheck, BiHash, BiX } from 'react-icons/bi'
import { BsChevronDown } from 'react-icons/bs'
import moment from 'moment'
import { Alert } from 'reactstrap'
import { IoCalendarClear } from 'react-icons/io5'

export default function MultirangeDatePickerDesigned({
  dateRange,
  handleDateChange,
  noAlert,
  headingText = 'Insights',
}) {
  if (noAlert) {
    return (
      <div>
        <DatePickerMulti
          value={dateRange}
          onChange={handleDateChange}
          range
          render={
            <Button
              className={
                dateRange && dateRange.length > 1
                  ? 'trivia-results-datepicker-added-dates'
                  : 'trivia_survey_datepicker_button'
              }
              children={
                dateRange && dateRange.length == 0 ? (
                  <React.Fragment>
                    <BiCalendarAlt className="mr-2" /> All Time{' '}
                    <BsChevronDown className="ml-5" />{' '}
                  </React.Fragment>
                ) : (
                  <span>
                    {' '}
                    {moment(dateRange[0]).format('MMM DD YYYY')} -{' '}
                    {moment(dateRange[1]).format('MMM DD YYYY')}{' '}
                    <span className="trivia-results-datepicker-added-dates-rightcross">
                      <BiX size={22} onClick={() => handleDateChange([])} />
                    </span>
                  </span>
                )
              }
            />
          }
        />
      </div>
    )
  }
  return (
    <div style={{ width: '500px' }}>
      <Alert className="d-flex align-items-center" color="primary">
        <h5
          style={{ fontWeight: 'bolder', marginBottom: '0px', color: 'black' }}>
          {headingText} as of{' '}
        </h5>
        <div
          className="ml-4 dp-w-manage"
          style={{ flex: 1, position: 'relative' }}>
          <DatePickerMulti
            value={dateRange}
            onChange={handleDateChange}
            range
            style={{ height: '40px', width: '100%' }}
            format="MM/DD/YYYY"
          />

          {/* <IoCalendarClear
            size={22}
            className="calendar-icon"
            style={{
              position: "absolute",
              right: "30px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
          /> */}
        </div>
      </Alert>
    </div>
  )
}
